import React from 'react';

export default class SortOrder extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            order: this.props.order
        };
    }

    componentWillReceiveProps(newProps) {
        this.setState({ order: newProps.order});
    }

    render() {
        let outerClass = "grid-sort-order" + (this.state.order ? " grid-sort-order-active" : "");

        let spanClass = "glyphicon glyphicon-sort";
        if (this.state.order === "asc") {
            spanClass = "glyphicon glyphicon-sort-by-attributes";
        } else if (this.state.order === "desc") {
            spanClass = "glyphicon glyphicon-sort-by-attributes-alt";
        }

        return (
            <div className={outerClass}>
                <span className={spanClass}></span>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/grid/sortOrder.jsx